export class DashboardColumnRQ {
  public dtVoo: string;

  constructor(){
    this.dtVoo = '';
  }
}
